export const AllocationTypes = [
    { value: 'BeneficiaryCash', label: 'Cash Lump Sum' },
    { value: 'Beneficiary', label: 'RA Annuity' },
    { value: 'CompulsoryAnnuity', label: 'Compulsory Annuity (Living or Life Annuity)' },
    { value: 'BeneficiaryAndCompulsoryAnnuity', label: 'Cash and Compulsory Annuity' },
    { value: 'BeneficiaryAndBeneficiary', label: 'Cash and RA Annuity' },
    { value: 'CompulsoryAnnuityAndBeneficiary', label: 'Compulsory Annuity and RA Annuity' },
    {
        value: 'BeneficiaryAndCompulsoryAnnuityAndBeneficiary',
        label: 'Cash, Compulsory Annuity and RA Annuity',
    },
];

export const Relationships = [
    { value: 'Spouse', label: 'Spouse' },
    { value: 'ExSpouse', label: 'Ex Spouse' },
    { value: 'EstrangedSpouse', label: 'Estranged Spouse' },
    { value: 'MinorChild', label: 'Minor Child (Younger than 18)' },
    { value: 'MajorChild', label: 'Major Child (18 years and older)' },
    { value: 'Relative', label: 'Relative' },
    { value: 'Parent', label: 'Parent' },
    { value: 'LifePartner', label: 'Life Partner' },
    { value: 'Other', label: 'Other' },
];

export const WTICountryies = [
    { value: 'AFG', label: 'Afghanistan - (WTI Percent = 15%)' },
    { value: 'ALA', label: 'Aland Islands - (WTI Percent = 15%)' },
    { value: 'ALB', label: 'Albania - (WTI Percent = 15 %)' },
    { value: 'DZA', label: 'Algeria - (WTI Percent = 10 %)' },
    { value: 'ASM', label: 'American Samoa - (WTI Percent = 15%)' },
    { value: 'AND', label: 'Andorra - (WTI Percent = 15 %)' },
    { value: 'AGO', label: 'Angola - (WTI Percent = 15 %)' },
    { value: 'AIA', label: 'Anguilla - (WTI Percent = 15 %)' },
    { value: 'ATA', label: 'Antarctica - (WTI Percent = 15 %)' },
    { value: 'AG', label: 'Antigua and Barbuda - (WTI Percent = 15%)' },
    { value: 'AR', label: 'Argentina - (WTI Percent = 15 %)' },
    { value: 'AM', label: 'Armenia - (WTI Percent = 15 %)' },
    { value: 'AW', label: 'Aruba - (WTI Percent = 15 %)' },
    { value: 'AU', label: 'Australia - (WTI Percent = 10 %)' },
    { value: 'AT', label: 'Austria - (WTI Percent = 0 %)' },
    { value: 'AZ', label: 'Azerbaijan - (WTI Percent = 15 %)' },
    { value: 'BS', label: 'Bahamas - (WTI Percent = 15 %)' },
    { value: 'BH', label: 'Bahrain - (WTI Percent = 15 %)' },
    { value: 'BD', label: 'Bangladesh - (WTI Percent = 15 %)' },
    { value: 'BB', label: 'Barbados - (WTI Percent = 15 %)' },
    { value: 'BY', label: 'Belarus - (WTI Percent = 10 %)' },
    { value: 'BE', label: 'Belgium - (WTI Percent = 10 %)' },
    { value: 'BZ', label: 'Belize - (WTI Percent = 15 %)' },
    { value: 'BJ', label: 'Benin - (WTI Percent = 15 %)' },
    { value: 'BM', label: 'Bermuda - (WTI Percent = 15 %)' },
    { value: 'BT', label: 'Bhutan - (WTI Percent = 15 %)' },
    { value: 'BO', label: 'Bolivia, Plurinational State of - (WTI Percent = 15%)' },
    { value: 'BQ', label: 'Bonaire, St Eustatius and Saba - (WTI Percent = 15%)' },
    { value: 'BA', label: 'Bosnia Herzegovina - (WTI Percent = 15%)' },
    { value: 'BW', label: 'Botswana - (WTI Percent = 10 %)' },
    { value: 'BV', label: 'Bouvet Island - (WTI Percent = 15%)' },
    { value: 'BR', label: 'Brazil - (WTI Percent = 15 %)' },
    { value: 'IO', label: 'British Indian Ocean Territory - (WTI Percent = 15%)' },
    { value: 'BN', label: 'Brunei Darussalam - (WTI Percent = 15%)' },
    { value: 'BG', label: 'Bulgaria - (WTI Percent = 5 %)' },
    { value: 'BF', label: 'Burkina Faso - (WTI Percent = 15%)' },
    { value: 'BI', label: 'Burundi - (WTI Percent = 15 %)' },
    { value: 'CA', label: 'Canada - (WTI Percent = 10 %)' },
    { value: 'KH', label: 'Cambodia - (WTI Percent = 15 %)' },
    { value: 'CM', label: 'Cameroon - (WTI Percent = 15 %)' },
    { value: 'CV', label: 'Cape Verde - (WTI Percent = 15%)' },
    { value: 'KY', label: 'Cayman Islands - (WTI Percent = 15%)' },
    { value: 'CF', label: 'Central African Republic - (WTI Percent = 15%)' },
    { value: 'TD', label: 'Chad - (WTI Percent = 15 %)' },
    { value: 'CL', label: 'Chile - (WTI Percent = 15 %)' },
    { value: 'CN', label: 'China - (WTI Percent = 10 %)' },
    { value: 'CX', label: 'Christmas Island - (WTI Percent = 15%)' },
    { value: 'CC', label: 'Cocos(Keeling) Islands - (WTI Percent = 15 %)' },
    { value: 'CO', label: 'Colombia - (WTI Percent = 15 %)' },
    { value: 'KM', label: 'Comoros - (WTI Percent = 15 %)' },
    { value: 'CG', label: 'Congo - (WTI Percent = 15 %)' },
    { value: 'CD', label: 'Congo, Democratic Republic of - (WTI Percent = 10%)' },
    { value: 'CK', label: 'Cook Islands - (WTI Percent = 15%)' },
    { value: 'CR', label: 'Costa Rica - (WTI Percent = 15%)' },
    { value: 'CI', label: 'Cote dIvoire - (WTI Percent = 15%)' },
    { value: 'HR', label: 'Croatia - (WTI Percent = 0%)' },
    { value: 'CU', label: 'Cuba - (WTI Percent = 15 %)' },
    { value: 'CW', label: 'Curacao - (WTI Percent = 15 %)' },
    { value: 'CY', label: 'Cyprus - (WTI Percent = 0 %)' },
    { value: 'CZ', label: 'Czech Republic - (WTI Percent = 0%)' },
    { value: 'DK', label: 'Denmark - (WTI Percent = 0 %)' },
    { value: 'DJ', label: 'Djibouti - (WTI Percent = 15 %)' },
    { value: 'DM', label: 'Dominica - (WTI Percent = 15 %)' },
    { value: 'DO', label: 'Dominican Republic - (WTI Percent = 15%)' },
    { value: 'EC', label: 'Ecuador - (WTI Percent = 15 %)' },
    { value: 'EG', label: 'Egypt - (WTI Percent = 12 %)' },
    { value: 'SV', label: 'El Salvador - (WTI Percent = 15%)' },
    { value: 'GQ', label: 'Equatorial Guinea - (WTI Percent = 15%)' },
    { value: 'ER', label: 'Eritrea - (WTI Percent = 15 %)' },
    { value: 'EE', label: 'Estonia - (WTI Percent = 15 %)' },
    { value: 'ET', label: 'Ethiopia - (WTI Percent = 8 %)' },
    { value: 'FK', label: 'Falkland Islands(Malvinas) -(WTI Percent = 15 %)' },
    { value: 'FO', label: 'Faroe Islands - (WTI Percent = 15%)' },
    { value: 'FJ', label: 'Fiji - (WTI Percent = 15 %)' },
    { value: 'FI', label: 'Finland - (WTI Percent = 0 %)' },
    { value: 'FR', label: 'France - (WTI Percent = 0 %)' },
    { value: 'GF', label: 'French Guiana - (WTI Percent = 15%)' },
    { value: 'PF', label: 'French Polynesia - (WTI Percent = 15%)' },
    { value: 'TF', label: 'French Southern Territories - (WTI Percent = 15%)' },
    { value: 'GA', label: 'Gabon - (WTI Percent = 15 %)' },
    { value: 'GM', label: 'Gambia - (WTI Percent = 15 %)' },
    { value: 'GE', label: 'Gambia - (WTI Percent = 15 %)' },
    { value: 'DE', label: 'Germany - (WTI Percent = 10 %)' },
    { value: 'GH', label: 'Ghana - (WTI Percent = 10 %)' },
    { value: 'GI', label: 'Gibraltar - (WTI Percent = 15 %)' },
    { value: 'GR', label: 'Greece - (WTI Percent = 8 %)' },
    { value: 'GL', label: 'Greenland - (WTI Percent = 15 %)' },
    { value: 'GD', label: 'Grenada - (WTI Percent = 15 %)' },
    { value: 'GP', label: 'Guadeloupe - (WTI Percent = 15 %)' },
    { value: 'GU', label: 'Guam - (WTI Percent = 15 %)' },
    { value: 'GT', label: 'Guatemala - (WTI Percent = 15 %)' },
    { value: 'GG', label: 'Guernsey - (WTI Percent = 15 %)' },
    { value: 'GN', label: 'Guinea - (WTI Percent = 15 %)' },
    { value: 'GW', label: 'Guinea - Bissau - (WTI Percent = 15 %)' },
    { value: 'GY', label: 'Guayana - (WTI Percent = 15 %)' },
    { value: 'HT', label: 'Haiti - (WTI Percent = 15 %)' },
    { value: 'HM', label: 'Heard Island and McDonald Islands - (WTI Percent = 15%)' },
    { value: 'VA', label: 'Holy See(Vatican City State) -(WTI Percent = 15 %)' },
    { value: 'HN', label: 'Honduras - (WTI Percent = 15 %)' },
    { value: 'HK', label: 'Hong Kong - (WTI Percent = 15%)' },
    { value: 'HU', label: 'Hungary - (WTI Percent = 0 %)' },
    { value: 'IS', label: 'Iceland - (WTI Percent = 15 %)' },
    { value: 'IN', label: 'India - (WTI Percent = 10 %)' },
    { value: 'ID', label: 'Indonesia - (WTI Percent = 10 %)' },
    { value: 'IR', label: 'Iran, Islamic Republic of - (WTI Percent = 5%)' },
    { value: 'IQ', label: 'Iraq - (WTI Percent = 15 %)' },
    { value: 'IE', label: 'Ireland - (WTI Percent = 0 %)' },
    { value: 'IM', label: 'Isle of Man - (WTI Percent = 15%)' },
    { value: 'IL', label: 'Israel - (WTI Percent = 25 %)' },
    { value: 'IT', label: 'Italy - (WTI Percent = 10 %)' },
    { value: 'JM', label: 'Jamaica - (WTI Percent = 15 %)' },
    { value: 'JP', label: 'Japan - (WTI Percent = 10 %)' },
    { value: 'JE', label: 'Jersey - (WTI Percent = 15 %)' },
    { value: 'JO', label: 'Jordan - (WTI Percent = 15 %)' },
    { value: 'KZ', label: 'Khazakhstan - (WTI Percent = 15 %)' },
    { value: 'KE', label: 'Kenya - (WTI Percent = 15 %)' },
    { value: 'KI', label: 'Kiribati - (WTI Percent = 15 %)' },
    { value: 'KP', label: 'Korea, Democratic People Republic - (WTI Percent = 15%)' },
    { value: 'KR', label: 'Korea, Republic of - (WTI Percent = 10%)' },
    { value: 'KW', label: 'Kuwait - (WTI Percent = 0 %)' },
    { value: 'KG', label: 'Kyrgystan - (WTI Percent = 15 %)' },
    { value: 'LA', label: 'Lao People Democratic Republic - (WTI Percent = 15%)' },
    { value: 'LV', label: 'Latvia - (WTI Percent = 15%)' },
    { value: 'LB', label: 'Lebanon - (WTI Percent = 15 %)' },
    { value: 'LS', label: 'Lesotho - (WTI Percent = 10 %)' },
    { value: 'LR', label: 'Liberia - (WTI Percent = 15 %)' },
    { value: 'LY', label: 'Libya - (WTI Percent = 15 %)' },
    { value: 'LI', label: 'Liechtenstein - (WTI Percent = 15 %)' },
    { value: 'LT', label: 'Lituania - (WTI Percent = 15 %)' },
    { value: 'LU', label: 'Luxembourg - (WTI Percent = 0 %)' },
    { value: 'MO', label: 'Macao - (WTI Percent = 15 %)' },
    { value: 'MK', label: 'Macedonia, the Former Yugoslav - (WTI Percent = 15%)' },
    { value: 'MG', label: 'Madagascar - (WTI Percent = 15 %)' },
    { value: 'MW', label: 'Malawi - (WTI Percent = 15 %)' },
    { value: 'MY', label: 'Malaysia - (WTI Percent = 10 %)' },
    { value: 'MV', label: 'Maldives - (WTI Percent = 15 %)' },
    { value: 'ML', label: 'Mali - (WTI Percent = 15 %)' },
    { value: 'MT', label: 'Malta - (WTI Percent = 10 %)' },
    { value: 'MH', label: 'Marshall Islands - (WTI Percent = 15%)' },
    { value: 'MQ', label: 'Martinique - (WTI Percent = 15 %)' },
    { value: 'MR', label: 'Mauritania - (WTI Percent = 15 %)' },
    { value: 'MU', label: 'Mauritius - (WTI Percent = 0 %)' },
    { value: 'YT', label: 'Mayotte - (WTI Percent = 15 %)' },
    { value: 'MX', label: 'Mexico - (WTI Percent = 10 %)' },
    { value: 'FM', label: 'Micronesia, Federated States of - (WTI Percent = 15%)' },
    { value: 'MD', label: 'Moldovia, Republic of - (WTI Percent = 15%)' },
    { value: 'MC', label: 'Monaco - (WTI Percent = 15 %)' },
    { value: 'MN', label: 'Mongolia - (WTI Percent = 15 %)' },
    { value: 'ME', label: 'Montenegro - (WTI Percent = 15 %)' },
    { value: 'MS', label: 'Montserrat - (WTI Percent = 15 %)' },
    { value: 'MA', label: 'Morocco - (WTI Percent = 15 %)' },
    { value: 'MZ', label: 'Mozambique - (WTI Percent = 8 %)' },
    { value: 'MM', label: 'Myanmar - (WTI Percent = 15 %)' },
    { value: 'NA', label: 'Namibia - (WTI Percent = 10 %)' },
    { value: 'NR', label: 'Nauru - (WTI Percent = 15 %)' },
    { value: 'NP', label: 'Nepal - (WTI Percent = 15 %)' },
    { value: 'NL', label: 'Netherlands - (WTI Percent = 0 %)' },
    { value: 'NC', label: 'New Caledonia - (WTI Percent = 15%)' },
    { value: 'NZ', label: 'New Zealand - (WTI Percent = 10%)' },
    { value: 'NI', label: 'Nicaragua - (WTI Percent = 15 %)' },
    { value: 'NE', label: 'Niger - (WTI Percent = 15 %)' },
    { value: 'NG', label: 'Nigeria - (WTI Percent = 7.5 %)' },
    { value: 'NU', label: 'Niue - (WTI Percent = 15 %)' },
    { value: 'NF', label: 'Norfolk Island - (WTI Percent = 15%)' },
    { value: 'MP', label: 'Northern Mariana Islands - (WTI Percent = 15%)' },
    { value: 'NO', label: 'Norway - (WTI Percent = 0 %)' },
    { value: 'OM', label: 'Oman - (WTI Percent = 0 %)' },
    { value: 'PK', label: 'Pakistan - (WTI Percent = 10 %)' },
    { value: 'PW', label: 'Palau - (WTI Percent = 15 %)' },
    { value: 'PS', label: 'Palestine, State of - (WTI Percent = 15%)' },
    { value: 'PA', label: 'Panama - (WTI Percent = 15 %)' },
    { value: 'PG', label: 'Papua New Guinea - (WTI Percent = 15%)' },
    { value: 'PY', label: 'Paraguay - (WTI Percent = 15 %)' },
    { value: 'PE', label: 'Peru - (WTI Percent = 15 %)' },
    { value: 'PH', label: 'Philipines - (WTI Percent = 15 %)' },
    { value: 'PN', label: 'Pitcairn - (WTI Percent = 15 %)' },
    { value: 'PL', label: 'Poland - (WTI Percent = 10 %)' },
    { value: 'PT', label: 'Portugal - (WTI Percent = 10 %)' },
    { value: 'PR', label: 'Puerto Rico - (WTI Percent = 15%)' },
    { value: 'QA', label: 'Qatar - (WTI Percent = 15 %)' },
    { value: 'RE', label: 'Reunion - (WTI Percent = 15 %)' },
    { value: 'RO', label: 'Romania - (WTI Percent = 15 %)' },
    { value: 'RU', label: 'Russian Federation - (WTI Percent = 10%)' },
    { value: 'RW', label: 'Rwanda - (WTI Percent = 10 %)' },
    { value: 'BL', label: 'St Barthelemy - (WTI Percent = 15%)' },
    { value: 'SH', label: 'St Helena, Ascension and Tristan da Cunha - (WTI Percent = 15%)' },
    { value: 'KN', label: 'St Kitts and Nevis - (WTI Percent = 15%)' },
    { value: 'LC', label: 'St Lucia - (WTI Percent = 15%)' },
    { value: 'MF', label: 'St Martin(French Part) -(WTI Percent = 15 %)' },
    { value: 'PM', label: 'St Pierre and Miquelon - (WTI Percent = 15%)' },
    { value: 'VC', label: 'St Vincent and the Grenadines - (WTI Percent = 15%)' },
    { value: 'WS', label: 'Samoa - (WTI Percent = 15 %)' },
    { value: 'SM', label: 'San Marino - (WTI Percent = 15%)' },
    { value: 'ST', label: 'Sao Tome and Principe - (WTI Percent = 15%)' },
    { value: 'SA', label: 'Saudi Arabia - (WTI Percent = 5%)' },
    { value: 'SN', label: 'Senegal - (WTI Percent = 15 %)' },
    { value: 'RS', label: 'Serbia - (WTI Percent = 15 %)' },
    { value: 'SC', label: 'Seychelles - (WTI Percent = 0 %)' },
    { value: 'SL', label: 'Sierra Leone - (WTI Percent = 15%)' },
    { value: 'SG', label: 'Singapore - (WTI Percent = 0 %)' },
    { value: 'SX', label: 'St Maarten(Dutch Part) -(WTI Percent = 15 %)' },
    { value: 'SK', label: 'Slovakia - (WTI Percent = 0 %)' },
    { value: 'SI', label: 'Slovenia - (WTI Percent = 15 %)' },
    { value: 'SB', label: 'Solomon Islands - (WTI Percent = 15%)' },
    { value: 'SO', label: 'Somalia - (WTI Percent = 15 %)' },
    { value: 'ZA', label: 'South Africa - (WTI Percent = 0%)' },
    { value: 'GS', label: 'South Georgia and South Sandwitch - (WTI Percent = 15%)' },
    { value: 'SS', label: 'South Sudan - (WTI Percent = 15%)' },
    { value: 'ES', label: 'Spain - (WTI Percent = 5 %)' },
    { value: 'LK', label: 'Sri Lanka - (WTI Percent = 15%)' },
    { value: 'SD', label: 'Sudan - (WTI Percent = 15 %)' },
    { value: 'SR', label: 'Suriname - (WTI Percent = 15 %)' },
    { value: 'SJ', label: 'Svalbard and Jan Mayen - (WTI Percent = 15%)' },
    { value: 'SZ', label: 'Swaziland - (WTI Percent = 10 %)' },
    { value: 'SE', label: 'Sweden - (WTI Percent = 0 %)' },
    { value: 'CH', label: 'Switzerland - (WTI Percent = 5 %)' },
    { value: 'SY', label: 'Syrian Arab Republic - (WTI Percent = 15%)' },
    { value: 'TW', label: 'Taiwan, Province of China - (WTI Percent = 10%)' },
    { value: 'TJ', label: 'Tajikistan - (WTI Percent = 15 %)' },
    { value: 'TZ', label: 'Tanzania, United Republic of - (WTI Percent = 10%)' },
    { value: 'TH', label: 'Thailand - (WTI Percent = 15 %)' },
    { value: 'TL', label: 'Timor - Leste - (WTI Percent = 15 %)' },
    { value: 'TG', label: 'Togo - (WTI Percent = 15 %)' },
    { value: 'TK', label: 'Tokelau - (WTI Percent = 15 %)' },
    { value: 'TO', label: 'Tonga - (WTI Percent = 15 %)' },
    { value: 'TT', label: 'Trinidad and Tobago - (WTI Percent = 15%)' },
    { value: 'TN', label: 'Tunisia - (WTI Percent = 12 %)' },
    { value: 'TR', label: 'Turkey - (WTI Percent = 10 %)' },
    { value: 'TM', label: 'Turkmenistan - (WTI Percent = 15 %)' },
    { value: 'TC', label: 'Turks and Caicos Islands - (WTI Percent = 15%)' },
    { value: 'TV', label: 'Tuvalu - (WTI Percent = 15 %)' },
    { value: 'UG', label: 'Uganda - (WTI Percent = 10 %)' },
    { value: 'UA', label: 'Ukraine - (WTI Percent = 10 %)' },
    { value: 'AE', label: 'United Arab Emirates - (WTI Percent = 15%)' },
    { value: 'GB', label: 'United Kingdom - (WTI Percent = 0%)' },
    { value: 'US', label: 'United States - (WTI Percent = 0%)' },
    { value: 'UM', label: 'United States Minor Outlying Islands - (WTI Percent = 15%)' },
    { value: 'UY', label: 'Uruguay - (WTI Percent = 15 %)' },
    { value: 'UZ', label: 'Uzbekistan - (WTI Percent = 15 %)' },
    { value: 'VU', label: 'Vanuatu - (WTI Percent = 15 %)' },
    { value: 'VE', label: 'Venezuela, Bolivarian Republic of - (WTI Percent = 15%)' },
    { value: 'VN', label: 'Viet Nam - (WTI Percent = 15%)' },
    { value: 'VG', label: 'Virgin Islands, British - (WTI Percent = 15%)' },
    { value: 'VI', label: 'Virgin Islands, US - (WTI Percent = 15%)' },
    { value: 'EH', label: 'Western Sahara - (WTI Percent = 15%)' },
    { value: 'YE', label: 'Yemen - (WTI Percent = 15 %)' },
    { value: 'ZM', label: 'Zambia - (WTI Percent = 15 %)' },
    { value: 'ZW', label: 'Zimbabwe - (WTI Percent = 15 %)' },
    { value: 'XX', label: 'Other - (WTI Percent = 15 %)' },
];

export const TaxDirectiveSourceCodes = [
    { value: '3901', label: '3901 Gratuities /Severance Benefits (PAYE)' },
    { value: '3902', label: '3902 Pension / RAF (PAYE) Not applicable from 2010' },
    { value: '3903', label: '3903 Pension / RAF (PAYE) Not applicable from 2008' },
    { value: '3904', label: '3904 Provident (PAYE) Not applicable from 2010' },
    { value: '3905', label: '3905 Provident (PAYE)Not applicable from 2008r' },
    { value: '3907', label: '3907 Other lump sums (PAYE)' },
    {
        value: '3908',
        label: '3908 Exempt Policy Proceeds (Excl) Applicable from 2006 year of assessment',
    },
    { value: '3909', label: '3909 Unclaimed benefits (PAYE)' },
    {
        value: '3915',
        label: '3915 Retirement/termination/Commutation of annuities(PAYE) Applicable from 2008',
    },
    { value: '3920', label: '3920 Lump sumwithdrawal benefits(PAYE)' },
    { value: '3921', label: '3921 Living annuity and surplus apportionments' },
    { value: '3922', label: '3922 Compensation i.r.o. death during employment (Excl / PAYE)' },
    {
        value: '3923',
        label: '3923 Transfer of Unclaimed Benefits (PAYE) Applicable from 2018 year of assessment',
    },
    {
        value: '3924',
        label: '3924 Transfer on Retirement (PAYE) Applicable from 2019 year of assessment',
    },
    { value: '3926', label: '3926 Savings Withdrawal' },
    { value: '3951', label: '3951 DNU Gratuities /Severance Benefits (PAYE)' },
    { value: '3952', label: '3952 Pension / RAF (PAYE) Not applicable from 2010' },
    { value: '3953', label: '3953 Pension / RAF (PAYE) Not applicable from 2008' },
    { value: '3954', label: '3954 Provident (PAYE) Not applicable from 2010' },
    { value: '3955', label: '3955 Provident (PAYE) Not applicable from 2008' },
    { value: '3957', label: '3957 DNU Other lump sums (PAYE)' },
];

export const WTIExceptionCodes = [
    {
        value: 'FS50D3AF',
        label:
            'S.50D(3)(a) Foreign(natural) person physically present in S.A for more than 183 days in aggregate during the twelve months prior to payment',
    },
    {
        value: 'GS50D3AF',
        label:
            'S.50D(3)(b) Debit claim connected with a permanent establishment in the Republic(and the foreign person is registered as a taxpayer in S.A)',
    },
    {
        value: 'HExemptNotTaxable',
        label: 'Exempt/ Not taxable in terms of double Taxation Agreement',
    },
    {
        value: 'IExemptNotTaxable',
        label: 'Exempt/ Not taxable in terms of another international agreement',
    },
    {
        value: 'XOtherComposite',
        label: 'Other/Composite',
    },
    { value: 'Notapplicable', label: 'O - Not applicable' },
];

export const NaturalRelationships = [
    { value: 'Partner', label: 'Partner' },
    { value: 'ExSpouse', label: 'Ex Spouse' },
    { value: 'EstrangedSpouse', label: 'Estranged Spouse' },
    { value: 'MinorChild', label: 'Minor Child (Younger than 18)' },
    { value: 'MajorChild', label: 'Major Child (18 years and older)' },
    { value: 'Husband', label: 'Husband' },
    { value: 'Wife', label: 'Wife' },
    { value: 'Brother', label: 'Brother' },
    { value: 'Sister', label: 'Sister' },
    { value: 'Cousin', label: 'Cousin' },
    { value: 'Child', label: 'Child' },
    { value: 'Son', label: 'Son' },
    { value: 'Daughter', label: 'Daughter' },
    { value: 'Grandparent', label: 'Grandparent' },
    { value: 'Grandchild', label: 'Grandchild' },
    { value: 'Grandson', label: 'Grandson' },
    { value: 'Granddaughter', label: 'Granddaughter' },
    { value: 'Niece', label: 'Niece' },
    { value: 'Nephew', label: 'Nephew' },
    { value: 'Employer', label: 'Employer' },
    { value: 'Father', label: 'Father' },
    { value: 'Mother', label: 'Mother' },
    { value: 'Grandfather', label: 'Grandfather' },
    { value: 'Grandmother', label: 'Grandmother' },
    { value: 'Uncle', label: 'Uncle' },
    { value: 'Aunt', label: 'Aunt' },
    { value: 'Executor', label: 'Executor' },
    { value: 'Other', label: 'Other' },
];

export const OrganisationRelationships = [
    { value: 'Partner', label: 'Partner' },
    { value: 'Employer', label: 'Employer' },
    { value: 'Creditor', label: 'Creditor' },
    { value: 'Lawyer/Attorney', label: 'Lawyer/Attorney' },
    { value: 'FinancialAdvisor', label: 'Financial Advisor' },
    { value: 'Other', label: 'Other' },
];

export const EntityAssigneeRelationships = [
    { value: 'AuthorisedPerson', label: 'Authorised Person' },
    { value: 'Co-Director', label: 'Co-Director' },
    { value: 'Co-Shareholder', label: 'Co-Shareholder' },
    { value: 'Director', label: 'Director' },
    { value: 'FamilyTrust', label: 'Family Trust' },
    { value: 'Founder', label: 'Founder' },
    { value: 'OrganizationPartner', label: 'Organization Partner' },
    { value: 'OwnerOfAnOrganisation', label: 'Owner of an organisation' },
    { value: 'Shareholder', label: 'Shareholder' },
    { value: 'TrustFounder', label: 'Trust Founder' },
    { value: 'TrustFund', label: 'Trust Fund' },
    { value: 'Trust', label: 'Trust' },
    { value: 'Trustee', label: 'Trustee' },
];

export const RelationshipsChildren = [
    { value: 'AdoptedDaughter', label: 'Adopted Daughter' },
    { value: 'AdoptedSon', label: 'Adopted Son' },
    { value: 'Daughter', label: 'Daughter' },
    { value: 'FosterDaughter', label: 'Foster Daughter' },
    { value: 'FosterSon', label: 'Foster Son' },
    { value: 'Goddaughter', label: 'Goddaughter' },
    { value: 'Godson', label: 'Godson' },
    { value: 'Grand-Daughter', label: 'Grand-Daughter' },
    { value: 'Granddaughter-In-Law', label: 'Granddaughter-In-Law' },
    { value: 'Grand-Nephew', label: 'Grand-Nephew' },
    { value: 'Grand-Niece', label: 'Grand-Niece' },
    { value: 'Grand-Son', label: 'Grand-Son' },
    { value: 'Grandson-In-Law', label: 'Grandson-In-Law' },
    { value: 'GreatGranddaughter', label: 'Great Granddaughter' },
    { value: 'GreatGrandson', label: 'Great Grandson' },
    { value: 'Great-Grandnephew', label: 'Great-Grandnephew' },
    { value: 'Great-Nephew', label: 'Great-Nephew' },
    { value: 'Great-Niece', label: 'Great-Niece' },
    { value: 'Nephew', label: 'Nephew' },
    { value: 'Niece', label: 'Niece' },
    { value: 'Son', label: 'Son' },
    { value: 'Step-Daughter', label: 'Step-Daughter' },
    { value: 'Step-Granddaughter', label: 'Step-Granddaughter' },
    { value: 'Step-Grandson', label: 'Step-Grandson' },
    { value: 'Step-Son', label: 'Step-Son' },
];

export const RelationshipsParents = [
    { value: 'AdoptedFather', label: 'Adopted Father' },
    { value: 'AdoptedMother', label: 'Adopted Mother' },
    { value: 'Father', label: 'Father' },
    { value: 'FosterFather', label: 'Foster Father' },
    { value: 'FosterMother', label: 'Foster Mother' },
    { value: 'Mother', label: 'Mother' },
    { value: 'Step-Father', label: 'Step-Father' },
    { value: 'Step-Mother', label: 'Step-Mother' },
];

export const RelationshipsSpouses = [
    { value: 'Wife', label: 'Wife' },
    { value: 'Husband', label: 'Husband' },
];

export const RelationshipsRelatives = [
    { value: 'Aunt', label: 'Aunt' },
    { value: 'AdoptedBrother', label: 'Adopted Brother' },
    { value: 'AdoptedSister', label: 'Adopted Sister' },
    { value: 'Brother', label: 'Brother' },
    { value: 'Brother-In-Law', label: 'Brother-In-Law' },
    { value: 'Cousin', label: 'Cousin' },
    { value: 'Daughter-In-Law', label: 'Daughter-In-Law' },
    { value: 'Father-In-Law', label: 'Father-In-Law' },
    { value: 'FosterBrother', label: 'Foster Brother' },
    { value: 'FosterSister', label: 'Foster Sister' },
    { value: 'Grandfather', label: 'Grandfather' },
    { value: 'Grandmother', label: 'Grandmother' },
    { value: 'Grandnephew', label: 'Grandnephew' },
    { value: 'Half-Brother', label: 'Half-Brother' },
    { value: 'Half-Sister', label: 'Half-Sister' },
    { value: 'Mother-In-Law', label: 'Mother-In-Law' },
    { value: 'Sister', label: 'Sister' },
    { value: 'Sister-In-Law', label: 'Sister-In-Law' },
    { value: 'Son-In-Law', label: 'Son-In-Law' },
    { value: 'Step-Brother', label: 'Step-Brother' },
    { value: 'Step-Grandfather', label: 'Step-Grandfather' },
    { value: 'Step-Grandmother', label: 'Step-Grandmother' },
    { value: 'Step-Sister', label: 'Step-Sister' },
    { value: 'Step-Son', label: 'Step-Son' },
    { value: 'Uncle', label: 'Uncle' },
];

export const RelationshipsPartner = [
    {
        value: 'Partner',
        label: 'Partner',
    },
];

export const RelationshipsExSpouses = [
    { value: 'Ex-Spouse', label: 'Ex-Wife' },
    { value: 'Ex-Spouse ', label: 'Ex-Husband' },
];

export const RelationshipsOther = [
    { value: 'CommonLawSpouse', label: 'Common-law Spouse' },
    { value: 'Curator', label: 'Curator' },
    { value: 'Employer', label: 'Employer' },
    { value: 'Executor', label: 'Executor' },
    { value: 'Fiance(Male)', label: 'Fiance (Male)' },
    { value: 'Fiancee(Female)', label: 'Fiancee (Female)' },
    { value: 'Friend', label: 'Friend' },
    { value: 'Guardian', label: 'Guardian' },
    { value: 'Lawyer/attorney', label: 'Lawyer/attorney' },
];

export const AllRelationships = [
    ...NaturalRelationships,
    ...OrganisationRelationships,
    ...EntityAssigneeRelationships,
    ...Relationships,
    ...RelationshipsChildren,
    ...RelationshipsSpouses,
    ...RelationshipsExSpouses,
    ...RelationshipsPartner,
    ...RelationshipsRelatives,
    ...RelationshipsParents,
    ...RelationshipsOther,
];

export function getRelationship(relationship?: string, description?: string) {
    if (relationship === 'Other') {
        return description;
    }
    if (!relationship || relationship === '') {
        return relationship;
    }
    const code = AllRelationships.filter(r => r.value === relationship)[0];
    return code ? code.label : relationship;
}
